module.exports = __webpack_public_path__ + "img/cemig-logo.a3c41ced.svg";